import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../../core/animations';
import { Location } from '@angular/common';

@Component({
  selector: 'spekwo-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class HeaderComponent implements OnInit {

  @Input() title: string;

  constructor(private location: Location) {
  }

  ngOnInit() {

  }

  backToHome() {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/common/header/header.component.ts